import React, { useEffect } from 'react'
import { noOp } from '../../../../shared/helpers'
import { useHybridFocusable } from '../../hooks/useHybridFocusable'

import type { FocusableButtonProps } from './types'
import cx from 'classnames'

const FocusableButtonTS = <T,>({
  children,
  onEnterPress = noOp,
  onArrowPress,
  onFocus = noOp,
  onBlur = noOp,
  className = '',
  disabled = false,
  focusKey,
  stealFocus,
  extraProps,
}: FocusableButtonProps<T>) => {
  const { ref, focusSelf, focused, isHovered } = useHybridFocusable({
    onEnterPress,
    onArrowPress,
    onFocus,
    onBlur,
    focusKey,
    extraProps,
    disabled,
  })

  useEffect(() => {
    if (stealFocus) {
      focusSelf()
    }
  }, [stealFocus, focusSelf])

  return (
    <button
      ref={ref}
      disabled={disabled}
      className={cx('focusable-button', className, {
        'focusable-button--focused': focused,
        'focusable-button--disabled': disabled,
        'focusable-button--hovered': isHovered,
      })}
    >
      {children}
    </button>
  )
}

export default FocusableButtonTS
